import { matchPath, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { processReactRoute } from '@Services/PageTitle';
import { paths } from '@AppRoutes/constants';

function PageTitleUpdater() {
  const location = useLocation();
  const params = useParams(); // Route params
  const searchParams = new URLSearchParams(location.search); // Query params

  const getRoutePattern = (pathname) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const [, pattern] of Object.entries(paths)) {
      const match = matchPath(pathname, {
        path: pattern,
        exact: true,
        strict: false,
      });
      if (match) {
        return match;
      }
    }

    return null;
  };

  useEffect(() => {
    const matchedRoute = getRoutePattern(location.pathname);
    if (!matchedRoute) {
      return;
    }
    processReactRoute({
      path: matchedRoute.path,
      params: {
        ...params,
        ...searchParams,
        ...location.state,
        ...matchedRoute.params,
      },
    });
    // params from useParams() is intentionally excluded from the dependency array.
    // In React Router v5, useParams() returns a new object reference on every render,
    // which causes this effect to fire on every Redux update (including when results
    // load), making screen readers re-announce the page title mid-session.
    // Path params needed for title computation already come from matchedRoute.params
    // (derived from location.pathname via matchPath), so excluding params here is safe.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  return null;
}

export default PageTitleUpdater;
